const ACTIONS = {
  INCREMENT_STEP: 'increment-step',
  SET_STEP: 'set-step',
  SET_PHONE: 'set-phone',
  SET_PINCODE: 'set-pincode',
};

export default ACTIONS;
